
import Vue, { PropType } from "vue";
import axios from "axios";
import anime from "animejs";
import {  KeyValuePairOfIntegerAndString, TaskPriority, Tasks_Detail } from "../../../types/Sapphire_dto";
import { TaskDetailStatus } from "../../../enums/TaskDetailStatus";
import {SweetAlertOptions} from 'sweetalert2';
import { EndDateType } from "../../../types/Sapphire_dto";
import { TaskFrequencyType } from "../../../types/Sapphire_dto";

export default Vue.extend({
  name: "task-item",
  props: {
    task: Object as PropType<Tasks_Detail>,
    status: Array as () => Array<KeyValuePairOfIntegerAndString>,
    reasons: Array as () => Array<KeyValuePairOfIntegerAndString>,
    times: Array as () => Array<KeyValuePairOfIntegerAndString>,
    usr: String,
  },
  data: function () {
    return {
      TaskDetailStatus,
      EndDateType,
      TaskFrequencyType,
      TaskPriority,
      showTaskConfirm: false,
      showStatusReason: false,
      showDatePicker: false,
      dateRequired: false,
      selectedStatus: TaskDetailStatus.Completed,
      selectedReason: 0,
      startTime: 0,
      endTime: 0,
      moveValue: "",
      approvalInput: "",
    };
  },
  computed: {
      showWarning() {
          let results = false;

          if ( this.selectedStatus == TaskDetailStatus.NoShow ) {
              results = true;
          }
          return results;
      },
  },
  methods: {
    formatPatientLink: function (pid) {
      return "PatientChartPage.aspx?setSelectedTab=PatientTasks&pid=" + pid;
    },
    showTaskConfirmOptions: function (e) {
      this.showTaskConfirm = true;
      e.preventDefault();
    },
    async confirmTask(e) {
      var vm = this;
      e.preventDefault();
      let errorFlag = false;
      var errorMsg = "<ul>";

      if (this.dateRequired && !this.moveValue) {
        errorFlag = true;
        errorMsg = errorMsg + "<li>Date is required for Rescheduled status.  </li>";
      }

      if (this.startTime > 0 && (this.endTime <= this.startTime)) {
        errorFlag = true;
        errorMsg = errorMsg + "<li>  End Time must be greater than Start Time. </li>";
      }

      if (errorFlag == false)
      {
        await axios.post(
          "../../../Common/Services/EhrTaskService.svc/SetConfirmTask",
          {
            approvalText: this.approvalInput,
            status: this.selectedStatus,
            reason: this.selectedReason,
            occurenceCount: this.task.MasterTask.OccurrenceCount,
            masterTaskID: this.task.MasterTask.ID,
            moveToDate: this.moveValue,
            taskDate: this.task.FormattedTaskDate,
            moveToStartTime: this.times[this.startTime].Value,
            moveToEndTime: this.times[this.endTime].Value,
            userID: vm.usr,
          }
        );
        this.showTaskConfirm = false;
        this.$emit("reload");

      } 
      else {
        this.$swal({
          title: "Error",
          html: errorMsg + "</ul>",
          icon: 'warning',
        }) as SweetAlertOptions

      }

    },
    cancelConfirm: function (e) {
      e.preventDefault();
      this.showTaskConfirm = false;
    },
    statusChanged: function (e) {
      var sel = e.currentTarget;
      var selected = parseInt(sel.options[sel.selectedIndex].value) || 0;
      var reasonCount = this.reasons.length || 0;

      //var reasonCount = $('*[data-taskstatusreason="' + specificID + '"] > option').length;
      //Reason is not required when status is equal to 1 (Completed) or 4 (Rescheduled/Moved).
      if ([1, 2, 4, 6].indexOf(selected) > -1) {
        //2 = No Show, 4 = Rescheduled
        if ([2, 4].indexOf(selected) > -1) {
          this.showDatePicker = true;
          this.dateRequired = false;
          this.showStatusReason = reasonCount > 0;

          if (selected === 4) {
            this.showStatusReason = false;
            this.dateRequired = true;
          }
        } else {
          this.showStatusReason = false;
          this.showDatePicker = false;
          this.dateRequired = false;
        }
      } else {
        this.showStatusReason = reasonCount > 0;
        this.showDatePicker = false;
        this.dateRequired = false;
      }
    },
    checkTaskDate: function (pastDueFlag) {
      if (pastDueFlag) {
        return "past-due";
      } else {
        return "due-today";
      }
    },
    setConfirmForEnter: function (el) {
      el.style.transform = "translateX(-100%)";
    },
    confirmEnter: function (el, done) {
      anime({
        targets: el,
        translateX: 0,
        easing: "easeInQuad",
        duration: 550,
        complete: done,
      });
    },
    confirmLeave: function (el, done) {
      anime({
        targets: el,
        translateX: "-100%",
        easing: "easeInQuad",
        duration: 400,
        complete: done,
      });
    },
    setStatusForEnter: function (el) {
      el.style.cssText = "opacity: 0;transform: translateY(-5px)";
    },
    statusEnter: function (el, done) {
      anime({
        targets: el,
        opacity: 1,
        translateY: 0,
        easing: "easeInQuad",
        duration: 550,
        complete: done,
      });
    },
    statusLeave: function (el, done) {
      anime({
        targets: el,
        opacity: 0,
        translateY: "-5px",
        easing: "easeOutQuad",
        duration: 400,
        complete: done,
      });
    },
  },
});
